<template>
  <div id="app">
    <component :is="layoutComponent" />
  </div>
</template>

<script>
import MainLayout from "./components/layouts/MainLayout.vue";
import DefaultLayout from "./components/layouts/DefaultLayout.vue";

export default {
  components: {
    MainLayout,
    DefaultLayout,
  },
  computed: {
    layoutComponent() {
      const layout = this.$route?.meta?.layout || "default";
      return layout === "main" ? MainLayout : DefaultLayout;
    },
  },
};
</script>
<style></style>
